import './template-collection.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCollection = (context) => {
  const templateCollectionSection = context.closest('.shopify-section');
  if (!templateCollectionSection) return;

  $('[grid-settings-wrapper] .grid-settings svg').each(function () {
    $(this).on('click', function (event) {
      const cols = $(this).attr('cols');
      const $grid_settings_wrapper = $("[grid-settings-wrapper]");
      $grid_settings_wrapper.removeClass();
      $grid_settings_wrapper.addClass('grid-' + cols + '-col');
    });
  });

  // Manage filters drawer opening/closing

  const filtersOpener = templateCollectionSection.querySelector('.collection__filters-opener');
  const filtersContainer = templateCollectionSection.querySelector('.filters__container');
  const filterClose = templateCollectionSection.querySelector('.filters-drawer__close');
  if (filtersOpener && filtersContainer) {
    filtersOpener.addEventListener('click', function () {
      filtersContainer.classList.add('open');
      document.querySelector('html').style.overflow = 'hidden';
    });

    if (filterClose) {
      filterClose.addEventListener('click', () => {
        filtersContainer.classList.remove('open');
        document.querySelector('html').style.overflow = '';
      });
    }

    var closeOnMouseUp = false;
    filtersContainer.addEventListener('mousedown', (e) => {
      if (!filtersContainer.classList.contains('open') || e.target.classList.contains('filters-drawer__content') || e.target.closest('.filters-drawer__content')) return;
      closeOnMouseUp = true;
    });

    filtersContainer.addEventListener('mouseup', (e) => {
      if (closeOnMouseUp) {
        filtersContainer.classList.remove('open');
        document.querySelector('html').style.overflow = '';
        closeOnMouseUp = false;
      }
    });
  }

  // Manage active filters' tags

  const activeFilters = templateCollectionSection.querySelector('#FacetFiltersForm .filters-drawer__active-filters');
  activeFilters.querySelectorAll('.filters-drawer__active-filters__filter').forEach(activeLabel => {
    activeLabel.addEventListener('click', function () {
      activeLabel.style.display = 'none';
    });
  });

  templateCollectionSection.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]').forEach(checkbox => {
    const activeLabel = activeFilters.querySelector(`label[for="${checkbox.id}"]`);

    checkbox.addEventListener('change', function () {
      if (activeLabel) {
        if (checkbox.checked) {
          activeLabel.style.display = '';
        } else {
          activeLabel.style.display = 'none';
        }
      }

      const filterContainer = checkbox.closest('[data-filter]');
      if (filterContainer) {
        const counterLabels = document.querySelectorAll(`#FacetFiltersForm [data-filter="${filterContainer.dataset.filter}"] [single-filter-active-counter]`);
        const checkedCounters = filterContainer.querySelectorAll('input[type="checkbox"]:checked').length;

        if (counterLabels.length > 0) {
          counterLabels.forEach(counterLabel => {
            counterLabel.innerText = `( ${checkedCounters} )`;

            if (checkedCounters <= 0) {
              counterLabel.style.display = 'none';
            } else {
              counterLabel.style.display = '';
            }
          });
        }
      }

      const generalCounter = document.querySelector('.collection__filters-opener [active-filters-counter]');
      if (generalCounter) {
        const activeFilters = document.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked').length;
        generalCounter.innerText = `( ${activeFilters} )`;
        if (activeFilters <= 0) {
          generalCounter.style.display = 'none';
        } else {
          generalCounter.style.display = '';
        }
      }
    });
  });

  // Manage filters removal

  const applyFilters = document.querySelector('.collection-filters__filter-drawer__btn--apply');
  const removeFilters = document.querySelector('.collection-filters__filter-drawer__btn--remove');
  removeFilters.addEventListener('click', () => {
    const selectedFilters = document.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked');
    if (selectedFilters.length > 0) {
      selectedFilters.forEach(checkbox => {
        checkbox.checked = false;

        const activeLabel = templateCollectionSection.querySelector(`label.filters-drawer__active-filters__filter[for="${checkbox.id}"]`);
        activeLabel.style.display = 'none';
      });

      const filterContainer = removeFilters.closest('[data-filter]');
      if (filterContainer) {
        const counterLabels = document.querySelectorAll(`#FacetFiltersForm [data-filter="${filterContainer.dataset.filter}"] [single-filter-active-counter]`);
        if (counterLabels.length > 0) {
          counterLabels.forEach(counterLabel => {
            counterLabel.innerText = '( 0 )';
            counterLabel.style.display = 'none';
          });
        }

        const generalCounter = document.querySelector('#FacetFiltersForm [active-filters-counter]');
        if (generalCounter) {
          const activeFilters = document.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked').length;
          generalCounter.innerText = `( ${activeFilters} )`;
          if (activeFilters <= 0) {
            generalCounter.style.display = 'none';
          } else {
            generalCounter.style.display = '';
          }
        }
      }

      applyFilters.click();
    }
  });

  // Manage collection menu

  const slidesContainer = templateCollectionSection.querySelector('.collection-header__main__menu');

  if (slidesContainer) {
    const slides = slidesContainer.querySelectorAll('.swiper-slide');
    const slidesCount = slides.length;

    if (slidesCount > 1) {
      const swiper = new Swiper(slidesContainer, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        768: {
          spaceBetween: 8
        }
      });
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
    window.dAgency.initTemplateCollection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
      window.dAgency.initTemplateCollection(el);
    });
  });
}
